import { computed, ref } from 'vue';

export type HelpeeSignupStep =
  | 'intro'
  | 'profile'
  | 'phone'
  | 'criteria'
  | 'redirect';

export function useSignupSteps(initialStep: HelpeeSignupStep = 'intro') {
  const currentStep = ref<HelpeeSignupStep>(initialStep);

  const goToStep = (step: HelpeeSignupStep) => {
    currentStep.value = step;
  };

  const isIntro = computed(() => currentStep.value === 'intro');
  const isProfile = computed(() => currentStep.value === 'profile');
  const isPhone = computed(() => currentStep.value === 'phone');
  const isCriteria = computed(() => currentStep.value === 'criteria');
  const isRedirect = computed(() => currentStep.value === 'redirect');

  return {
    currentStep,
    goToStep,
    isIntro,
    isProfile,
    isPhone,
    isCriteria,
    isRedirect,
  };
}
